<template>
  <v-container class="article">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50"  >
            <h1><v-icon large>mdi-newspaper</v-icon>{{ $t('article.articles')}}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <v-row>
      <v-col md="12">
        <ArticleForm
          ref="updateForm"
          v-if="item"
          :values="item"
          :errors="violations"
        />
     </v-col>
   </v-row>
    <Loading :visible="isLoading || deleteLoading" />
  </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ArticleForm from '../../components/article/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import AccessMixin from '../../mixins/AccessMixin';

const servicePrefix = 'Article';

export default {
  name: 'ArticleUpdate',
  servicePrefix,
  mixins: [UpdateMixin,AccessMixin],
  components: {
    Loading,
    Toolbar,
    ArticleForm,
  },

  computed: {
    ...mapFields('article', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('article', ['find'])

  },

  methods: {
    ...mapActions('article', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
